import { components, OptionProps } from "react-select";
import {
  PUBLIC_USER_STATUS,
  PUBLIC_USER_STATUS_TO_TEXT,
} from "common/constants";
import { ROLES_TO_TEXT } from "common/utils/users";
import { Body } from "../Common/Typography";
import { OptionContainer } from "../Inputs/__styles__/MultiSelect";
import { OptionHeader } from "./__styles__/UserSelect";
import { UserOption } from "./UserSelect";

export const InviteOption = (
  option: UserOption,
  props: OptionProps<UserOption, true>,
) => {
  if (option.isNewEmailInvite) {
    return (
      <components.Option {...props}>
        <OptionContainer>
          <Body size="large" type="emphasis" color="contentInfo">
            {`+ Invite '${option.email}'`}
          </Body>
        </OptionContainer>
      </components.Option>
    );
  }

  if (option.isInvite) {
    return (
      <components.Option {...props}>
        <OptionContainer>
          <OptionHeader>
            <Body size="large" type="regular" color="contentPrimary">
              {option.email}
            </Body>
            {option.role && (
              <Body size="large" type="regular" color="contentSecondary">
                {ROLES_TO_TEXT[
                  option.role.name as keyof typeof ROLES_TO_TEXT
                ] || option.role.name}
              </Body>
            )}
          </OptionHeader>
          <Body size="large" type="regular" color="contentSecondary">
            Invite sent
          </Body>
        </OptionContainer>
      </components.Option>
    );
  }

  const isDisabledUser =
    option.status === PUBLIC_USER_STATUS.SUSPENDED ||
    option.status === PUBLIC_USER_STATUS.DENIED;
  const textColor = isDisabledUser ? "contentDisabled" : "contentPrimary";
  const secondaryColor =
    isDisabledUser ? "contentDisabled" : "contentSecondary";

  return (
    <components.Option {...props}>
      <OptionContainer>
        <OptionHeader>
          <Body size="large" type="regular" color={textColor}>
            {`${option.firstName} ${option.lastName}`}
          </Body>
          {option.status && option.status !== PUBLIC_USER_STATUS.ACTIVE && (
            <Body size="large" type="regular" color={secondaryColor}>
              {PUBLIC_USER_STATUS_TO_TEXT[
                option.status as PUBLIC_USER_STATUS
              ] ?? option.status}
            </Body>
          )}
          {option?.role && !isDisabledUser && (
            <Body size="large" type="regular" color="contentSecondary">
              {ROLES_TO_TEXT[option.role.name as keyof typeof ROLES_TO_TEXT] ||
                option.role.name}
            </Body>
          )}
        </OptionHeader>
        <Body size="large" type="regular" color={secondaryColor}>
          {option.email}
        </Body>
      </OptionContainer>
    </components.Option>
  );
};
